import { render, staticRenderFns } from "./BankTables.vue?vue&type=template&id=67cebd26&scoped=true&"
import script from "./BankTables.vue?vue&type=script&lang=js&"
export * from "./BankTables.vue?vue&type=script&lang=js&"
import style0 from "./BankTables.vue?vue&type=style&index=0&id=67cebd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cebd26",
  null
  
)

export default component.exports